import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/store/store";
import { getIsResourceTypeHiddenByFeatureToggle } from "@/components/pages/live-usage-mgmt/utils/helpers/getIsResourceTypeHiddenByFeatureToggle";
import { cloudChiprApi, ResourceType } from "@/services/cloudchipr.api";
import { generateKubernetesFilterTreeByFilters } from "@/store/kubernetes-live-usage-mgmt/thunks/resources/utils/helpers/generateKubernetesFilterTreeByFilters";
import { kubernetesLiveUsageMgmtSelectedClusterIdsSelector } from "@/store/kubernetes-live-usage-mgmt/selectors/store-selectors/kubernetesLiveUsageMgmtSelectedClusterIdsSelector";
import { kubernetesLiveUsageMgmtAppliedFiltersByResourceTypeSelector } from "@/store/kubernetes-live-usage-mgmt/selectors/filters/kubernetesLiveUsageMgmtAppliedFiltersByResourceTypeSelector";

export const getK8SLiveUsageResourceMetadataThunk = createAsyncThunk(
  "liveUsageMgmt/getK8SLiveUsageResourceMetadata",
  async (resourceType: ResourceType, { dispatch, getState }) => {
    const state = getState() as RootState;
    const clusterIds = kubernetesLiveUsageMgmtSelectedClusterIdsSelector(state);

    if (getIsResourceTypeHiddenByFeatureToggle(resourceType)) {
      return;
    }

    if (!clusterIds) {
      return;
    }

    const appliedFilter =
      kubernetesLiveUsageMgmtAppliedFiltersByResourceTypeSelector(
        state,
        resourceType,
      );

    const filterTree = generateKubernetesFilterTreeByFilters({
      filter: appliedFilter,
      clusterIds: clusterIds ?? [],
    });

    dispatch(
      cloudChiprApi.endpoints.postUsersMeOrganisationsCurrentKubernetesByTypeResources.initiate(
        {
          type: resourceType,
          body: { load_resources: false, filter: filterTree },
        },
        { fixedCacheKey: resourceType },
      ),
    ).unwrap();
  },
);
